import { Box } from '@mui/material'
import React from 'react'

const ACDProgressBar = ({ progress, sx, progressColor = 'alternate.main' }) => {
  return (
    <Box
      width="300px"
      height="8px"
      borderRadius="4px"
      backgroundColor="#EDEFF0"
      sx={{ ...sx }}
      overflow="hidden"
    >
      <Box
        sx={{ width: `${progress ? progress : 0}%`, transition: 'width 0.3s linear' }}
        height="100%"
        borderRadius="4px"
        backgroundColor={progressColor}
      />
    </Box>
  )
}

export default ACDProgressBar
